<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        HISTORY
    </div>
    <div class="card-body">
        <div class="row">
            <table datatable [dtOptions]="dtOptionsTrackingHistory" [dtTrigger]="dtTrigger" id="trackingHistory"
                class="customeDatatable table table-bordered" name="trackingHistory" style="font-size: xx-small !important">
            </table>
        </div>
    </div>
    <div class="card-footer p-2">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn  btn-sm btn-outline-primary me-1" (click)="close()"
                    [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                    Cancel
                    <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>
            </div>
        </div>
    </div>
</div>